module.exports = __webpack_public_path__ + "static/img/cover.06d510d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_12/cover.jpg
// module id = +5BN
// module chunks = 0